import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="relative border-t border-zinc-200 dark:border-white/5 bg-zinc-50 dark:bg-[#040404] pt-20 pb-10"
        >
            <div className="max-w-7xl mx-auto px-6 sm:px-8">
                <div className="grid md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-3">
                            <img src="/goodmax-symbol.png?v=3" alt="GOODMAX" className="h-14 w-auto" />
                            <div className="flex flex-col leading-none">
                                <span className="font-heading font-black tracking-tight text-zinc-950 dark:text-white text-2xl">
                                    GOODMAX
                                </span>
                                <span className="text-[0.7rem] uppercase tracking-[0.18em] text-zinc-500 dark:text-zinc-400 mt-1">
                                    Gestão de Serviços
                                </span>
                            </div>
                        </div>
                        <p className="mt-5 text-zinc-600 dark:text-zinc-400 max-w-md leading-relaxed">
                            GOODMAX Gestão de Serviços LTDA. Soluções operacionais com ética, transparência e melhoria contínua, para empresas e órgãos públicos em todo o território nacional.
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <div className="text-xs uppercase tracking-wider text-zinc-500 dark:text-zinc-500">Navegação</div>
                        <ul className="mt-4 space-y-2 text-zinc-700 dark:text-zinc-300">
                            {[
                                ["quem-somos", "Quem Somos"],
                                ["servicos", "Serviços"],
                                ["cases", "Cases"],
                                ["trabalhe-conosco", "Trabalhe Conosco"],
                                ["contato", "Contato"],
                            ].map(([id, label]) => (
                                <li key={id}>
                                    <a
                                        data-testid={`footer-link-${id}`}
                                        href={`#${id}`}
                                        className="hover:text-[#E89546] transition-colors"
                                    >
                                        {label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <div className="text-xs uppercase tracking-wider text-zinc-500 dark:text-zinc-500">Contato</div>
                        <ul className="mt-4 space-y-3 text-sm text-zinc-700 dark:text-zinc-300">
                            <li className="flex items-start gap-3">
                                <Phone className="w-4 h-4 text-[#E89546] mt-0.5" />
                                <span>(71) 99174-0168 · (71) 98882-8619</span>
                            </li>
                            <li className="flex items-start gap-3">
                                <Mail className="w-4 h-4 text-[#E89546] mt-0.5" />
                                <span>jorge@goodmaxgestao.com.br<br />juan@goodmaxgestao.com.br</span>
                            </li>
                            <li className="flex items-start gap-3">
                                <MapPin className="w-4 h-4 text-[#E89546] mt-0.5" />
                                <span>
                                    Rua Francisco Gonçalves, 01 · Edf. Reitor Miguel Calmon, Sala 702 · Comércio, Salvador-BA
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-14 pt-8 border-t border-zinc-200 dark:border-white/5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-zinc-500 dark:text-zinc-500">
                    <div>© {new Date().getFullYear()} GOODMAX Gestão de Serviços LTDA. Todos os direitos reservados.</div>
                    <div>Ética · Transparência · Melhoria Contínua</div>
                </div>
            </div>
        </footer>
    );
}
